const SET_SPONSOR_PRODUCTS = 'SET_SPONSOR_PRODUCTS';
const RESET_SPONSOR_PRODUCTS = 'RESET_SPONSOR_PRODUCTS';
const SET_SPONSOR_PRODUCTS_FAILURE = 'SET_SPONSOR_PRODUCTS_FAILURE';

export {
    SET_SPONSOR_PRODUCTS, RESET_SPONSOR_PRODUCTS, SET_SPONSOR_PRODUCTS_FAILURE
};
